import { render, staticRenderFns } from "./BigCheckbox.vue?vue&type=template&id=1bef9bc6&scoped=true"
import script from "./BigCheckbox.vue?vue&type=script&lang=js"
export * from "./BigCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BigCheckbox.vue?vue&type=style&index=0&id=1bef9bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef9bc6",
  null
  
)

export default component.exports